import { FileUpload, FileUploadRequest } from "@edp-models/file-upload.model";
import { Action } from "@ngrx/store";

export enum EFileUploadActions {
    UploadFile = "[Upload] Uploading file",
    SaveUploadedFile = "[Upload] Saving uploaded file",
    ClearUploadedFile = "[Upload] Clear uploaded file",
    ClearAndroidFile = "[Upload] Clear android file",
    RemoveUploadedFile = "[Upload] Remove file",
    AddUploadedFile = "[Upload] Add file",
    ClearUploadedFiles  = "[Upload] Clear uploaded files",
    UploadCustomerSupportFile = "[Upload] Uploading customer support file",
    UploadCustomerSupportMultiFiles = "[Upload] Uploading customer support multi files"
}

export class UploadFile implements Action {
    public readonly type = EFileUploadActions.UploadFile;
    constructor(public payload: FileUploadRequest) {}
}

export class SaveUploadedFile implements Action {
    public readonly type = EFileUploadActions.SaveUploadedFile;
    constructor(public payload: FileUpload) {}
}

export class ClearUploadedFile implements Action {
    public readonly type = EFileUploadActions.ClearUploadedFile;
}

export class ClearAndroidFile implements Action {
    public readonly type = EFileUploadActions.ClearAndroidFile;
}

export class RemoveUploadedFile implements Action {
    public readonly type = EFileUploadActions.RemoveUploadedFile;
    constructor(public payload: FileUpload) {}
}
export class ClearUploadedFiles implements Action {
    public readonly type = EFileUploadActions.ClearUploadedFiles;
}


export class AddUploadedFile implements Action {
    public readonly type = EFileUploadActions.AddUploadedFile;
    constructor(public payload: FileUpload) {}
}

export class UploadCustomerSupportFile implements Action {
    public readonly type = EFileUploadActions.UploadCustomerSupportFile;
    constructor(public payload: any) {}
}

export class UploadCustomerSupportMultiFiles implements Action {
    public readonly type = EFileUploadActions.UploadCustomerSupportMultiFiles;
    constructor(public payload: { files: Array<any> }) {}
}

export type FileUploadActions = UploadFile
    | SaveUploadedFile
    | ClearUploadedFile
    | ClearAndroidFile
    | RemoveUploadedFile
    | ClearUploadedFiles
    | AddUploadedFile
    | UploadCustomerSupportFile
    | UploadCustomerSupportMultiFiles;
